export default __webpack_public_path__ + "static/media/x.3433c594.svg";